<template>
  <section class="form-config sr-qiankun-view">
    <div class="total-page">
      <el-tabs v-model="activeName" @click="handleClick">
        <el-tab-pane
          v-for="(item, index) in editableTabs"
          :key="String(index)"
          :label="item.title"
          :name="String(index)"
        >
          <span slot="label" class="tabsLabel"
            ><i class="el-icon-date"></i>{{ item.title }}</span
          >
          <div
            v-for="(item1, index1) in item.formArr"
            :key="index1"
            class="tabsData"
          >
            <div class="tabsDataTitle">{{ item1.title }}</div>
            <SrView
              v-if="item1.selectData.formView"
              :formData="item1.selectData.formView.config"
              :ruleForm="item1.selectData.formView.data"
            >
            </SrView>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>
<script>
export default {
  name: "SrQiankunView",
  inject: ["baseUrl", "imgBaseUrl", "uploadBaseUrl"],
  props: {
    editableTabs: {
      type: Array,
    },
  },
  data() {
    return {
      activeName: "0",
    };
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      
    },
  },
};
</script>
<style lang="scss" scoped>
.sr-qiankun-view {
  .searchPage {
    display: flex;
    justify-content: space-between;
  }
  .searchRightBtn {
    display: inline-block;
    button {
      width: 76px;
      height: 32px;
      border-radius: 16px;
      padding: 5px 24px;
    }
  }
  .tabsLabel {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
    i {
      margin-right: 4px;
    }
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 16px !important;
  }
  .tabsDataTitle {
    margin-top: 8px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
    margin-bottom: 13px;
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// packages/SrQiankunView/SrQiankunView.vue